<template>
    <div>
        <Confirm ref="confirm" width="400"></Confirm>
        <ConfirmDelete
            ref="confirmDelete"
            @modelChanged="$emit('modelChanged', $event)"
        />
        <FixCategory
            ref="fixCategory"
            @modelChanged="$emit('modelChanged', $event)"
        />
        <StoreSupplier
            ref="storeSupplier"
            @modelChanged="$emit('modelChanged', $event)"
        />
        <NotifyCustomers
            ref="notifyCustomers"
            @modelChanged="$emit('modelChanged', $event)"
        />
    </div>
</template>

<script>
import Confirm from '@/shared/components/Confirm'
import ConfirmDelete from '@/shared/components/ConfirmDelete'
import FixCategory from './FixCategory'
import StoreSupplier from './StoreSupplier'
import NotifyCustomers from './NotifyCustomers'

export default {
    components: {
        Confirm,
        ConfirmDelete,
        FixCategory,
        StoreSupplier,
        NotifyCustomers,
    },

    methods: {
        async activate(model) {
            let confirm = await this.$refs.confirm.open(
                this.$t('actions.reseller.activate.title'),
                this.$t('actions.reseller.activate.text', {
                    name: model.trade_name,
                }),
            )

            if (!confirm) return

            let res = await model.activate()

            if (!res) return

            this.$emit('modelChanged', model)
            this.$bus.$emit(
                'notify',
                'warning',
                this.$t('actions.reseller.activate.success'),
            )
        },

        async delete(model) {
            await this.$refs.confirmDelete.open(model, model.trade_name)
        },

        async restore(model) {
            let confirmed = await this.$refs.confirm.open(
                this.$t('actions.restore.title'),
                this.$t('actions.restore.text', {
                    name: model.trade_name,
                }),
            )
            if (!confirmed) return

            await model.restore()

            this.$emit('modelChanged')
            this.$bus.$emit(
                'notify',
                'success',
                this.$t('actions.restore.success'),
            )
        },

        async fixCategory(model) {
            await this.$refs.fixCategory.open(model)
        },

        async storeSupplier(model) {
            await this.$refs.storeSupplier.open(model)
        },

        async notifyCustomers(model) {
            await this.$refs.notifyCustomers.open(model)
        },
    },
}
</script>

<style></style>
